import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { useToastSeeker } from "@ui-seeker/app"
import { deleteSubmit, getSubmit, postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"
import { isEditUserSettingsOfficesGroupDrawer, isLoadingUserSettingOfficesGroupData, userSettingsOfficesGroupFormData, userSettingOfficesGroupData } from "../@signals"


export default function useUserSettingsOfficesGroup(rowData={}) {
	const { showToast } = useToastSeeker()
	const isLoading = useSignal(false)

	const getOfficesGroupData = useCallback(() => {
		getSubmit(`${BACKEND_APIS.CRUD}/user/offices_group`)
			.then(data => userSettingOfficesGroupData.value = data)
			.catch(() => {
				showToast.error()
				userSettingOfficesGroupData.value = []
			}).finally(() => isLoadingUserSettingOfficesGroupData.value = false)
	}, [])

	const handleSetOfficesGroupFormData = useCallback(() => userSettingsOfficesGroupFormData.value = {
		id: rowData.id || null,
		service_type: SERVICES_TYPE.OFFICE_GROUP,
		name: rowData.name || "My Office Group",
		offices: rowData.offices || []
	}, [JSON.stringify(rowData)])

	const handleChangeOfficesGroupFormData = useCallback((newValue, prop) => userSettingsOfficesGroupFormData.value = {
		...userSettingsOfficesGroupFormData.value,
		[prop]: newValue
	}, [])

	const handleSubmitOfficesGroupFormData = useCallback(() => {
		isLoading.value = true
		postSubmit(`${BACKEND_APIS.CRUD}/${!isEditUserSettingsOfficesGroupDrawer.value ? 'add' : 'update'}`, userSettingsOfficesGroupFormData.value).then(res => {
			if (isEditUserSettingsOfficesGroupDrawer.value) {
				userSettingOfficesGroupData.value = [
					...userSettingOfficesGroupData.value.map(item => item.id === userSettingsOfficesGroupFormData.value.id ? res : item)
				]
			} else {
				userSettingOfficesGroupData.value = [
					...userSettingOfficesGroupData.value,
					res
				]
			}
			userSettingsOfficesGroupFormData.value = {}
		}).catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	const handleDeleteOfficesGroup = useCallback(() => showToast.confirm(`Are you sure you want to delete this row? This action cannot be undone.`, {
		onSubmit: () => {
			isLoading.value = true
			deleteSubmit(`${BACKEND_APIS.CRUD}/delete/${SERVICES_TYPE.OFFICE_GROUP}?id=${rowData.id}`).then(() => {
				userSettingOfficesGroupData.value = [
					...userSettingOfficesGroupData.value.filter(item => item.id !== rowData.id)
				]
			}).catch(() => showToast.error())
				.finally(() => isLoading.value = false)
		}
	}), [JSON.stringify(rowData)])

	return {
		isClicked: rowData.id === userSettingsOfficesGroupFormData.value.id,
		isLoading: isLoading.value,
		getOfficesGroupData,
		handleSetOfficesGroupFormData,
		handleChangeOfficesGroupFormData,
		handleSubmitOfficesGroupFormData,
		handleDeleteOfficesGroup
	}
}